import { CommonHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const DeleteCartItemData = (cartItemId, state, setState) => {
  if (state.isObjLoading !== true && !state.message) {
    const newState = {
      ...state,
      isObjLoading: true,
      isObjLoaded: false,
      isSaving: true,
      isSaved: false,
      message: 'Deleting...'
    };
    setState(newState);

    const cartItemIdForUrl = cartItemId ? encodeURIComponent(cartItemId) : 'NaN';
    const url = `/cartItem/${cartItemIdForUrl}`;
    CommonHttpHelper(url, 'DELETE')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            objData,
            isObjLoading: false,
            isObjLoaded: true,
            isSaving: false,
            isSaved: true,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoading: false,
          isObjLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default DeleteCartItemData;